import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import VideoPageDisplay from '../components/videoPlayer/VideoPageDisplay'
import Unauthorized from '../components/errorPages/Unauthorized'
import PaymentRequired from '../components/errorPages/PaymentRequired'
import NotFound from '../components/errorPages/NotFound'
import Forbidden from '../components/errorPages/Forbidden'
import ServerError from '../components/errorPages/ServerError'
import VideoPageError from '../components/errorPages/VideoPageError'
import { getVideo } from '../components/videoPlayer/hooks/getVideo'
import { setVideoUrl, setExpirationTime, setVideoId, setBooleanState } from '../features/videoPlayer/videoPlayer.slice'
import VideoPlayer from '../components/videoPlayer/VideoPlayer'
import PageLoader from '../components/loaders/PageLoader'

const VideoPage = () => {

    const [authResponse, setAuthResponse] = useState(null);
    const [authDescription, setAuthDescription] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    //Fetch id from URL which should be last part of the URL
    const { id } = useParams();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchVideoData = async () => {
            try {
                const fetchVideo = await getVideo(id);
                if (fetchVideo) {
                    setTimeout( () => {
                        setIsLoading(false);
                        setAuthResponse(fetchVideo.status);
                        setAuthDescription(fetchVideo.message);
                        dispatch(setVideoUrl(fetchVideo.videoUrl));
                        dispatch(setExpirationTime(fetchVideo.expirationTime));
                        dispatch(setVideoId(id));
                    }, 5000); // Simulate a loading time of 5 seconds

                } else {
                    setAuthResponse(500); // Set to 500 for server error
                }
            } catch (error) {
                console.error('Error fetching video:', error);
                setAuthResponse(500); // Handle unexpected errors
            }
        };

        dispatch(setBooleanState({ key: 'isBuffering', value: true }));
        fetchVideoData();
    }, [id]);

    return (
        <div>
            {
                authResponse === 500 || authResponse === 401 || authResponse === 402 || authResponse === 403 || authResponse === 404 || authResponse === 409 ?
                    <VideoPageError status={authResponse} message={authDescription} />
                : authResponse === 200 ?
                    // Must pass a URI eventually for the presigned URL to work but for now it's fine since it is utilizing youtube videos
                    <VideoPageDisplay id={id}/>
                :
                    <PageLoader isLoading={isLoading} />
            }
        </div>
    )
}

export default VideoPage